module.exports = __webpack_public_path__ + "img/6.a1706c46.jpg";